import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

// Campo de busca AgSUS — submete para a página de resultados nativa /search
// (?SearchableText=...). No modo edição não navega.
const SearchView = ({ data, isEdit }) => {
  const history = useHistory();
  const [q, setQ] = React.useState('');
  const placeholder = data?.placeholder || 'Pesquisar';

  const submit = (e) => {
    e.preventDefault();
    if (isEdit) return;
    const term = (q || '').trim();
    history.push(
      `/search${term ? `?SearchableText=${encodeURIComponent(term)}` : ''}`,
    );
  };

  return (
    <form className="ag-searchblock" role="search" onSubmit={submit}>
      <input
        type="search"
        className="ag-searchblock__input"
        placeholder={placeholder}
        value={q}
        onChange={(e) => setQ(e.target.value)}
        aria-label={placeholder}
      />
      <button type="submit" className="ag-searchblock__btn" aria-label="Buscar">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </button>
    </form>
  );
};

SearchView.propTypes = {
  data: PropTypes.shape({
    placeholder: PropTypes.string,
  }).isRequired,
  isEdit: PropTypes.bool,
};

export default SearchView;
